<div class='SelectManagerDialog'>
  <div class='SelectManagerDialog__header'>
    <div *ngIf="currentUser.user_type === 'master' && user.account_role === 'user'" class='alert alert-danger'>
      <p>You are about to change the management of the user.</p>
      <p>If user was previously assigned under another manager, the old manager's user will be decreased. The new
        manager will absorb the monthly cost of the new user. Admin can configure setting who pays for this user in the
        Subscriptions tab</p>
    </div>
  </div>
  <div [formGroup]='inputForm' class='SelectManagerDialog__body'>
    <div class='SelectManagerDialog__body__selection'>
      <app-select
        *ngIf="currentUser.user_type === 'master' && user.account_role === 'user'"
        [defaultValue]='0'
        [items]='getManagers()'
        [label]="'Select manager'"
        formControlName='manager_id'></app-select>
      <mat-icon (click)='resetManager()' *ngIf='user.manager_id'>close</mat-icon>
    </div>
    <ng-container *ngIf="user.account_role !== 'manager'; else managedUsers">
      <div *ngIf='manager_id !== user.manager_id && manager_id !== ""' class='SelectManagerDialog__body__controls'>
        <p>Subscription paid by</p>
        <mat-radio-group
          aria-label='Select an user type' formControlName='paid_by'>
          <mat-radio-button class='me-2' value='manager'>New Manager</mat-radio-button>
          <mat-radio-button class='ms-2' value='user'>User {{ user.account_id }}, {{ user.email }}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class='alert alert-warning mt-5'>
        <p>To maintain proper integration between the Retreva app and Stripe, always ensure the same <code>stripe
          customer_id</code> is used.</p>

        <ul>
          <li>
            If the user is marked for QuickBooks or No billing&nbsp;&mdash; no Stripe subscription is required to use
            the app.
          </li>

          <li>
            If the user is on Stripe (or not marked QuickBooks / No billing yet)
            <strong>and</strong> is not assigned to any manager&nbsp;&mdash; a valid subscription is required.
          </li>

          <li>
            When assigning a manager:
            <ul>
              <li>
                In the <em>Manager</em> column you can specify who pays the subscription while the user is under a
                manager:
                <ul>
                  <li>If the manager pays&nbsp;&mdash; an additional <code>+1</code> user cost is added to the manager&#39;s
                    subscription.
                  </li>
                  <li>If the user pays&nbsp;&mdash; the user&#39;s own subscription continues unchanged.</li>
                </ul>
              </li>
            </ul>
          </li>

          <li>
            If a user with an existing subscription is attached to a manager who pays&nbsp;&mdash; the user&#39;s
            subscription is terminated.
          </li>

          <li>
            If a user under a manager is detached from a manager who pays&nbsp;&mdash; the user will have no active
            subscription and must provide payment details to create a new one.
          </li>

          <li>
            If a user is under a manager and an admin moves that user to a different manager:
            <ul>
              <li>In the <em>Manager</em> column, when a new manager is selected, a radio button &ldquo;Subscription
                paid by&rdquo; will appear.
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </ng-container>
    <ng-template #managedUsers>
      <app-table
        *ngIf='tableReady'
        [columns]='tableColumns'
        [dataSourceParams]='dataSourceParams'
        [dataSource]='dataSource'
        [emptyDataText]='emptyDataText'
        [selectable]='false'></app-table>
    </ng-template>
  </div>
</div>
